import { Routes } from '@angular/router';
import { authGuard, authGuardChild } from './core/guards/auth.guard';
import { adminGuard, adminGuardChild } from './core/guards/admin.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'users',
    canActivate: [authGuard, adminGuard],
    canActivateChild: [authGuardChild, adminGuardChild],
    loadChildren: () => import('./features/user-management/user-management.routes').then(m => m.USER_MANAGEMENT_ROUTES)
  },
  {
    path: 'systems',
    canActivate: [authGuard, adminGuard],
    canActivateChild: [authGuardChild, adminGuardChild],
    loadChildren: () => import('./features/system-management/system-management.routes').then(m => m.SYSTEM_MANAGEMENT_ROUTES)
  },
  {
    path: 'dashboard',
    canActivate: [authGuard, adminGuard],
    canActivateChild: [authGuardChild, adminGuardChild],
    loadChildren: () => import('./features/dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES)
  },
  {
    path: 'clients/:clientId',
    canActivate: [authGuard, adminGuard],
    loadComponent: () =>
      import('./features/oauth-clients/pages/client-details/client-details.component')
        .then(m => m.ClientDetailsComponent)
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('./shared/pages/unauthorized.component').then(m => m.UnauthorizedComponent)
  },
  {
    path: '**',
    loadComponent: () => import('./shared/pages/not-found.component').then(m => m.NotFoundComponent)
  }
];
